import { render, staticRenderFns } from "./DoctorListSelectAll.vue?vue&type=template&id=390f5126&scoped=true"
import script from "./DoctorListSelectAll.vue?vue&type=script&lang=js"
export * from "./DoctorListSelectAll.vue?vue&type=script&lang=js"
import style0 from "./DoctorListSelectAll.vue?vue&type=style&index=0&id=390f5126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f5126",
  null
  
)

export default component.exports